<script setup>
import GlobalEmitter from '~/glxp/utils/emitter'
import { useIsMobile } from '~~/composables/useIsMobile'
import { useModalStore } from '~/store/modal'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  video: {
    type: Object,
    required: true,
  },
  copy: {
    type: String,
    default: null,
  },
  videoGtmClass: {
    type: String,
    default: null,
  },
  thumbnail: {
    type: String,
    default: null,
  },
})

/**
 * Display
 */
const modalStore = useModalStore()
const isMobile = useIsMobile()
const showPreview = ref(false)
const layout = computed(() =>
  showPreview.value && !isMobile.value ? 'video-preview' : 'x-small'
)

watchEffect(() => {
  if (isMobile.value && showPreview.value) {
    modalStore.modal = 'video-preview'
  } else {
    modalStore.modal = ''
  }
})

/**
 * Events
 */
function openPreview() {
  showPreview.value = true
}

function closePreview() {
  showPreview.value = false
}

onMounted(() => {
  GlobalEmitter.on('unreveal', closePreview)
  GlobalEmitter.on('closeModal', closePreview)
})

onBeforeUnmount(() => {
  GlobalEmitter.off('unreveal', closePreview)
  GlobalEmitter.off('closeModal', closePreview)
})
</script>

<template>
  <CardContent
    :eyebrow="$t('contentCard.watch')"
    icon="video"
    :layout="layout"
    :title="title"
    :thumbnail="thumbnail"
    :video="video"
    :copy="showPreview ? copy : null"
    :useAction="!showPreview"
    :video-gtm-class="videoGtmClass"
    @click="openPreview"
    @close="closePreview"
    v-bind="$attrs"
  />

  <Teleport v-if="isMobile && showPreview" to="#global-modal">
    <CardContent
      class="video-preview-modal"
      :eyebrow="$t('contentCard.watch')"
      icon="video"
      layout="video-preview"
      :title="title"
      :thumbnail="thumbnail"
      :video="video"
      :copy="showPreview ? copy : null"
      modal
      @close="closePreview"
    />
  </Teleport>
</template>

<style lang="scss">
.video-preview-modal {
  z-index: 100;
}
</style>
